import React from 'react';
import Modal from '../Modal/Modal';
import IconCollection from '../IconCollection/IconCollection';
import { IconSpinner } from '..';

import css from './FolderDocumentModal.module.css';
import { FOLDER_DOCUMENT_PAGE_SIZE } from '../../containers/MyGroupCommunityPage/MyGroupCommunityPage.duck';
import PaginationMyActivity from '../../containers/CircleCommunityPage/components/MyActivity/PaginationMyActivity';
import {
  getCloudinaryPdfThumbnail,
  getDocumentFileType,
  getCommunityUserRole,
} from '../../util/data';

const FolderDocumentModal = props => {
  const {
    isFolderDocument,
    onToggelFolderDocument,
    onManageDisableScrolling,
    spaceDetail,
    fetchFolderDocumentRequest,
    fetchFolderDocumentError,
    allFolderDocuments,
    updateFolderDocumentRequest,
    updateFolderDocumentError,
    onUpdateGroupDocumentFolder,
    onFetchGroupDocumentFolder,
    onToggelAddFolder,
    intl,
    toastifyFn,
    userModeratorsGroups,
    checkClickOnDocumnets,
    isOpenElephantModal,
    onSetElephantVerificationModal = () => {},
  } = props;

  const { folderName } = isFolderDocument || {};

  const { can_manage_space, can_view_space } = spaceDetail?.policies || {};
  const userRoleInGroup = getCommunityUserRole(userModeratorsGroups, spaceDetail?.id);
  const userHaveDocumnetViewPermissions =
    ['admin', 'moderator'].includes(userRoleInGroup) || can_view_space;
  const userHaveDocumnetUpadtePermissions = ['admin', 'moderator'].includes(userRoleInGroup);

  const deleteDocumentSuccess = intl.formatMessage({
    id: 'FolderDocumentModal.deleteDocumentSuccess',
  });
  const deleteDocumentError = intl.formatMessage({ id: 'FolderDocumentModal.deleteDocumentError' });

  const { data: allFolderDocumentData, pagination } = allFolderDocuments || {};

  const { totalItems, totalPages, page, perPage } = pagination || {};

  const onDeleteFolder = item => {
    const { _id, groupId, folderId } = item;

    const deleteData = {
      id: _id,
      payload: {
        isDelete: true,
        groupId,
        folderId,
      },
    };

    const fetchData = {
      payload: {
        groupId,
        folderId,
        isActive: true,
        isDelete: false,
      },
      pageParams: {
        page: page > 1 && allFolderDocumentData.length > 1 ? page : 1,
        perPage: FOLDER_DOCUMENT_PAGE_SIZE,
      },
    };

    return onUpdateGroupDocumentFolder(deleteData, fetchData)
      .then(res => {
        toastifyFn('success', deleteDocumentSuccess);
        return res;
      })
      .catch(e => {
        toastifyFn('error', deleteDocumentError);
        console.log(e, '&&& &&& => e');
        return e;
      });
  };

  const handlePageChange = newPage => {
    const { groupId, folderId } = allFolderDocumentData?.[0] || [];
    onFetchGroupDocumentFolder({
      payload: {
        groupId,
        folderId,
        isActive: true,
        isDelete: false,
      },
      pageParams: {
        page: newPage,
        perPage: FOLDER_DOCUMENT_PAGE_SIZE,
      },
    });
  };

  return (
    <Modal
      id={'folderDocumentModal'}
      isOpen={!!(isFolderDocument && userHaveDocumnetViewPermissions)}
      onClose={() => onToggelFolderDocument(false)}
      onManageDisableScrolling={onManageDisableScrolling}
      className={css.folderModal}
    >
      <div className={css.modalContainer}>
        <div className={css.header}>
          <span>{folderName}</span>
          {userHaveDocumnetUpadtePermissions ? (
            <span
              data-testid="folder-document-modal-edit-button"
              className={css.icon}
              onClick={e => {
                e.preventDefault();
                console.log(isFolderDocument, 'isFolderDocument');
                onToggelAddFolder(isFolderDocument);
                onToggelFolderDocument(false);
              }}
            >
              <IconCollection name="editIcon" />
            </span>
          ) : null}
        </div>
        {fetchFolderDocumentRequest ? (
          <div className={css.spinner}>
            <IconSpinner />
          </div>
        ) : fetchFolderDocumentError ? (
          <div className={css.noDataText}>
            {intl.formatMessage({ id: 'FolderDocumentModal.fetchFolderDocumentError' })}
          </div>
        ) : (
          <>
            <ul className={css.documentList}>
              {userHaveDocumnetViewPermissions &&
              Array.isArray(allFolderDocumentData) &&
              allFolderDocumentData.length ? (
                allFolderDocumentData.map(item => (
                  <li key={item.id} className={css.documentItem}>
                    <div className={css.documentName}>
                      <div className={css.documentIcon}>
                        {checkClickOnDocumnets && !isOpenElephantModal ? (
                          getCloudinaryPdfThumbnail(item.documentURL) ? (
                            <img
                              src={getCloudinaryPdfThumbnail(item.documentURL)}
                              width="46"
                              height="62"
                              alt=""
                              style={{ objectFit: 'cover', display: 'block' }}
                              onError={e => {
                                e.currentTarget.style.display = 'none';
                              }}
                            />
                          ) : (
                            <div
                              className={css.fileTypeBadge}
                              data-ext={getDocumentFileType(item.documentURL)}
                            >
                              <span>{getDocumentFileType(item.documentURL)}</span>
                            </div>
                          )
                        ) : (
                          <div className={css.documentIconPlaceholder}>
                            <IconCollection name="documentIcon" />
                          </div>
                        )}
                      </div>
                      {checkClickOnDocumnets ? (
                        isOpenElephantModal ? (
                          <p
                            className={`${css.linkText} ${css.linkTextClickable}`}
                            onClick={e => {
                              e.preventDefault();
                              e.stopPropagation();
                              onSetElephantVerificationModal(true);
                            }}
                          >
                            {item.documentName}
                          </p>
                        ) : (
                          <a
                            className={css.linkText}
                            target="_blank"
                            href={item.documentURL}
                            rel="noopener noreferrer"
                          >
                            {item.documentName}
                          </a>
                        )
                      ) : (
                        <p className={css.linkText}>{item.documentName}</p>
                      )}
                    </div>
                    {userHaveDocumnetUpadtePermissions ? (
                      <span
                        className={css.deleteIcon}
                        onClick={e => {
                          e.preventDefault();
                          if (!updateFolderDocumentRequest) {
                            onDeleteFolder(item);
                          }
                        }}
                        data-testid="folder-document-modal-delete-button"
                      >
                        {updateFolderDocumentRequest == item._id ? (
                          <IconSpinner />
                        ) : (
                          <IconCollection name="deleteIcon" />
                        )}
                      </span>
                    ) : null}
                  </li>
                ))
              ) : (
                <li key={'No folder documents found'}>
                  <div className={css.noDataText}>
                    {intl.formatMessage({ id: 'FolderDocumentModal.noDocumentsFound' })}
                  </div>
                </li>
              )}
            </ul>
          </>
        )}
        {totalPages > 1 ? (
          <PaginationMyActivity
            currentPage={page}
            hasNextPage={page < totalPages}
            onPageChange={handlePageChange}
            posts_count={totalItems}
            per_page={perPage}
            isActiveTab={'documents'}
          />
        ) : null}
      </div>
    </Modal>
  );
};

export default FolderDocumentModal;
